import { createTelemetry } from '@shared/core';

const category = 'GuestGuide';

const { TelemetryProvider: GuestGuideTelemetryProvider, useTelemetry: useGuestGuideTelemetry } = createTelemetry({
  actions: {
    guideShown: () => ({
      action: 'GuestGuideShown',
      category,
    }),
    clickAddToCalendar: () => ({
      action: 'AddToCalendar',
      actionType: 'click',
      category,
    }),
    clickEditRsvp: () => ({
      action: 'EditRsvp',
      actionType: 'click',
      category,
    }),
    clickCarRentals: () => ({
      action: 'CarRentals',
      actionType: 'click',
      category,
    }),
    clickBrowseHotels: () => ({
      action: 'BrowseHotels',
      actionType: 'click',
      category,
    }),
    clickBrowseRegistry: () => ({
      action: 'BrowseRegistry',
      actionType: 'click',
      category,
    }),
    clickRemindMeToBookStay: () => ({
      action: 'RemindMeToBookStay',
      actionType: 'click',
      category,
    }),
  },
});
export { GuestGuideTelemetryProvider, useGuestGuideTelemetry };
